import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";

import { SignalElement } from "ui-common/di";
import { getAssetUrl } from "helpers/assetHelpers";
import type { ChatType } from "api-contracts/rpc/notifications";

import { chatNotificationCardStyles } from "./chat-notification-card.css";

export interface ChatNotificationCardData {
  chatType: ChatType;
  chatId: string;
  title: string;
  thumbnailUrl: string | null;
  ownerHandle: string;
  unreadCount: number;
}

@customElement("chat-notification-card")
export class ChatNotificationCard extends SignalElement {
  static override styles = chatNotificationCardStyles;

  @property({ type: Object }) notification!: ChatNotificationCardData;

  private _handleClick() {
    const { chatType, chatId, ownerHandle } = this.notification;
    const section = chatType === "community" ? "communities" : "live-events";
    window.location.href = `/${ownerHandle}/${section}/${chatId}#chat`;
  }

  private renderThumbnail() {
    const path = this.notification.thumbnailUrl;
    if (path) {
      return html`<img class="chat-thumbnail" src=${getAssetUrl(path)} alt=${this.notification.title} />`;
    }
    return html`<div class="chat-thumbnail-fallback">${this.notification.title.charAt(0).toUpperCase()}</div>`;
  }

  private get label(): string {
    const count = this.notification.unreadCount;
    const suffix = count === 1 ? "message" : "messages";
    return `${count > 99 ? "99+" : count} new ${suffix}`;
  }

  protected override render() {
    if (!this.notification) return nothing;

    return html`
      <div class="notification-card unread" @click=${this._handleClick}>
        ${this.renderThumbnail()}
        <div class="notification-content">
          <div class="chat-title">${this.notification.title}</div>
          <div class="chat-count">${this.label}</div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "chat-notification-card": ChatNotificationCard;
  }
}
